<template>
	<div
		class="product_wrap col-lg-2 col-md-3 col-sm-4 col-xs-6 product_item product_item_data"
		:class="{
			hideproduct: index >= shownumproducts,
			product_wrap_big:
				((index + 16) % 18 == 0 &&
					this.$route.name != 'home' &&
					this.$route.name != 'permenent' &&
					(typeof friend == 'undefined' || !friend)) ||
				((index / 9) % 2 == 1 && this.$route.name != 'home' && (typeof friend == 'undefined' || !friend)), //||
			//	(this.$route.name == 'home' && index == 5 && (typeof friend == 'undefined' || !friend)),
			//      product_wrap_big: this.$route.name == 'home' && index == 5,
			product_wrap_big_1:
				(index + 16) % 18 == 0 &&
				this.$route.name != 'home' &&
				this.$route.name != 'permenent' &&
				(typeof friend == 'undefined' || !friend),
			product_wrap_big_2: ((index / 9) % 2 == 1 && typeof friend == 'undefined') || !friend,
			has_friend: product.cross_sell_ids && product.cross_sell_ids.length > 0 && !is_popup,
			product_in_cart: product.quantity,
			on_sale: product.onsale,
			organic: product.tags ? product.tags.includes(19) : false,
			glutenfree: product.tags ? product.tags.includes(18) : false,
			[productsView]: true,
      product_friend_show: showFriend,
      first: index
		}"
		v-bind:data-product-id="product.id"
	>
		<div
			class="product clearfix"
			v-bind:class="{ hasQuantity: product.quantity }"
			@click.prevent.once="weightAndQuantityPopup(product)"
		>
			<div class="product-main">
				<div class="product_big_bg">
					<div class="product_big_in"></div>
				</div>
				<div class="remove_fav">
					<a
						href="javascript:void(0);"
						v-if="this.$route.name != 'permenent'"
						@click="toggleFav([product, $event])"
					>
						<span class="ease">הסר</span>
						<close_svg />
					</a>
					<a
						href="javascript:void(0);"
						v-if="this.$route.name == 'permenent'"
						@click="removePermenent([product, $event])"
					>
						<span class="ease">הסר</span>
						<close_svg />
					</a>
				</div>
				<div class="my-heart" v-bind:class="{ active: isFav }">
					<a
						href="javascript:void(0);"
						class
						:class="{ hasTooltip: $mq != 'mobile' }"
						title="הוספה למועדפים שלי"
						@click="toggleFav([product, $event])"
					></a>
				</div>
				<a
					class="edit-link"
					:class="{ hasTooltip: $mq != 'mobile' }"
					title="עריכת מוצר"
					:href="`/wp-admin/post.php?post=${product.id}&action=edit`"
					target="_blank"
					v-if="wpData.user.isAdmin"
				>
					<pen />
				</a>
				<div class="product_img_wrap">
					<div class="mobile_only plus_m" v-if="this.productsView === 'list'">
						<a href="javascript:void(0);" onclick="openAbove();">
							<span
								class="plus_m_start"
								@click="
									incrementProduct([product, $event]);
									gaTag_friend();
								"
							>
								<plus_svg></plus_svg>
							</span>
							<span :key="product.quantity" ref="quantiy" class="plus_m_selected">{{
								product.quantity
							}}</span>
							<span class="plus_m_unit" :key="selectedText" ref="selectedText">{{ selectedText }}</span>
						</a>
					</div>
					<div class="prod_above absolute ease no_mobile">
						<div class="mobile_only m_prod_above_close">
							<a href="javascript:void(0);" @click.prevent="closeAboveGrid($event)">
								<close_svg />
							</a>
						</div>
						<div class="table100">
							<div class="table_cell">
								<div class="pr_plus_first absolute">
									<div class="table100">
										<div class="table_cell">
											<a
												href="javascript:void(0);"
												v-if="!isReadOnly"
												@click="
													incrementProduct([product, $event]);
													gaTag_friend();
												"
											>
												<plus_svg></plus_svg>
											</a>
										</div>
									</div>
								</div>
								<div class="addto_cart">
									<div class="addto_cart_in">
										<input
											class="addto_cart_num"
											v-bind:readonly="isReadOnly"
											type="number"
											formnovalidate
											@change="updateCart([product, $event])"
											v-model="product.quantity"
										/>
										<div class="plus">
											<a
												href="javascript:void(0);"
												v-if="!isReadOnly"
												@click="incrementProduct([product, $event])"
											>
												<plus_svg />
											</a>
										</div>
										<div class="minus">
											<a
												href="javascript:void(0);"
												v-if="!isReadOnly"
												@click="decrementProduct([product, $event])"
											>
												<minus_svg />
											</a>
										</div>
									</div>
									<Producttype v-bind:product="product"></Producttype>
								</div>
							</div>
						</div>
					</div>
					<div v-if="product.image" class="product_img" @click="openPop()">
						<img v-if="lazy_image" v-lazy="product.image" />
						<img v-else="lazy_image" :src="product.image" />
					</div>
					<div v-else class="product_img" @click="openPop()">
						<img v-lazy="wpData.assets_url + '/layout/empty.jpg'" />
					</div>
					<div class="flex pod_icon_wrap">
						<div class="new-product mobile_only" v-if="product.is_new">
							<new_svg />
						</div>
						<div class="pod_icon no-gluten" v-if="product.tags && product.tags.indexOf(18) !== -1">
							ללא גלוטן
						</div>
						<div class="pod_icon organic" v-if="product.tags && product.tags.indexOf(19) !== -1">
							אורגני
						</div>
						<div class="pod_icon vegan" v-if="product.tags && product.tags.indexOf(365) !== -1">טבעוני</div>
						<div class="pod_icon frozen" v-if="product.tags && product.tags.indexOf(1904) !== -1">
							קפוא
							<snow />
						</div>
						<div class="pod_icon israeli" v-if="product.tags && product.tags.indexOf(2937) !== -1">
							תוצרת<br />ישראל
						</div>
						<div class="pod_icon tollmans" v-if="product.tags && product.tags.indexOf(3786) !== -1">
							<img
								src="/wp-content/themes/carmella/carmella-vue/src/assets/img/LOGO DOT YELLOW.png"
								alt="tollmans dot"
							/>
						</div>
					</div>
					<div class="prod_selected_num">{{ product.quantity }}</div>
				</div>
				<div class="prod_bottom">
					<a href="javascript:void(0);" @click.prevent="openPop()">
						<span class="table100">
							<span class="table_cell">
								<span class="mobile_only">
									<h3 class="pr_title" v-html="product.name"></h3>
									<span class="pr_title_note" v-if="!product.hide_weight && product.weight">{{
										weightText
									}}</span>
								</span>
								<span class="pr_row_price">
									<span class="inline clearfix">
										<span
											class="pr_price"
											v-bind:class="{ price_sale: product.onsale && product.oldprice }"
										>
											{{ product.price | currency("") }}
											<span class="currency">{{ wpData.currencySumbol }}</span>
										</span>
										<span class="pr_price_kilo"
											>/
											{{ product.after_price_text ? product.after_price_text : unitPriceText }}
										</span>
										<span class="pr_price_old" v-if="product.oldprice">
											{{ product.oldprice | currency("") }}
											<span class="currency">{{ wpData.currencySumbol }}</span>
										</span>
									</span>
								</span>
								<span class="pr_title_sale" v-if="sale && sale.bannertext">{{ sale.bannertext }}</span>
								<span class="no_mobile">
									<h3 class="pr_title" v-html="product.name"></h3>
									<span class="pr_title_note" v-if="product.hide_weight != '1' && product.weight">{{
										weightText
									}}</span>
									<span
										class="pr_title_note pricePer100"
										v-if="product.hide_weight != '1' && product.weight && pricePer100(product)"
									>
										{{ pricePer100Text(product) }}
									</span>
								</span>
								<span class="mobile_only">
									<span
										class="pr_title_note pricePer100"
										v-if="product.hide_weight != '1' && product.weight && pricePer100(product)"
									>
										{{ pricePer100Text(product) }}
									</span>
								</span>
								<div class="new-product no_mobile" v-if="product.is_new">
									<new_svg />
								</div>
							</span>
						</span>
					</a>
				</div>
			</div>

			<div class="mobile_only mobile-add-to-cart" ref="prod_above">
				<a href="javascript:void(0);" @click.prevent="openAboveGrid($event)">
					<span
						@click="
							incrementProduct([product, $event]);
							gaTag_friend();
						"
						v-if="product.quantity === 0"
					>
						הוספה לסל
					</span>
					<div class="in_cart" v-if="product.quantity > 0">
						<span>{{ product.quantity }}</span>
						<div >
              <div class="addto_amount clearfix amount_one" v-if="(product.type == 'unit' || (product.type == 'both' && product.selected == 'unit')) && !product.case && !product.spread">{{ product.quantity > 1 ? 'יחידות' : 'יחידה'}}</div>
              <div class="addto_amount clearfix amount_one" v-if="product.type == 'kg' || (product.type == 'both' && product.selected == 'kg')" >ק"ג</div>
              <div class="addto_amount clearfix amount_one" v-if="!product.case && product.type == 'unitaskg'">{{ product.quantity > 1 ? 'יחידות' : 'יחידה'}}</div>
              <div class="addto_amount clearfix amount_one" v-if="product.case && (product.type == 'unit' || product.type == 'unitaskg')">{{ product.quantity > 1 ? 'מארזים' : 'מארז'}}</div>
            </div>
						בסל
					</div>
				</a>
				<div class="prod_above absolute ease">
					<div class="m_prod_above_close">
						<a href="javascript:void(0);" @click.prevent="closeAboveGrid($event)">
							<close_svg />
						</a>
					</div>
					<div class="table100">
						<div class="table_cell">
							<div class="pr_plus_first absolute">
								<div class="table100">
									<div class="table_cell">
										<a
											href="javascript:void(0);"
											v-if="!isReadOnly"
											@click="
												incrementProduct([product, $event]);
												gaTag_friend();
											"
										>
											<plus_svg></plus_svg>
										</a>
									</div>
								</div>
							</div>
							<div class="addto_cart">
								<div class="addto_cart_in">
									<input
										class="addto_cart_num"
										v-bind:readonly="isReadOnly"
										type="number"
										formnovalidate
										@change="updateCart([product, $event])"
										v-model="product.quantity"
									/>
									<div class="plus">
										<a
											href="javascript:void(0);"
											v-if="!isReadOnly"
											@click="incrementProduct([product, $event])"
										>
											<plus_svg />
										</a>
									</div>
									<div class="minus">
										<a
											href="javascript:void(0);"
											v-if="!isReadOnly"
											@click="decrementProduct([product, $event])"
										>
											<minus_svg />
										</a>
									</div>
								</div>
								<Producttype v-bind:product="product"></Producttype>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			class="product_friend"
			v-if="product.cross_sell_ids && product.cross_sell_ids.length > 0 && productCrossSale && !isPermenentPage"
		>
			<div class="pp_friend_title">יכול ללכת מצויין עם...</div>
			<div class="mobile_only m_prod_above_close">
				<a href="javascript:void(0);" @click.prevent="closeProductFriend($event);">
					<close_svg />
				</a>
			</div>
			<Product
				v-bind:product="productCrossSale"
				v-bind:index="index"
				v-bind:friend="true"
				v-bind:shownumproducts="shownumproducts"
			></Product>
		</div>
	</div>
</template>
<script>
	import Product from "./Product";
	import Producttype from "./ProductType";
	import plus_svg from "../../assets/img/plus.svg";
	import minus_svg from "../../assets/img/minus.svg";
	import close_svg from "../../assets/img/close.svg";
	import snow from "../../assets/img/snow.svg";
	import new_svg from "../../assets/img/new.svg";
	import pen from "../../assets/img/pen.svg";
	import { mapActions, mapGetters, mapState } from "vuex";

	export default {
		name: "Product",
		props: {
			product: {
				type: Object,
				required: true,
			},
			category: {},
			index: {},
			shownumproducts: {},
			is_popup: {},
			friend: { type: Boolean, required: false },
			readonly: {},
			lazy_image: { type: Boolean, default: true },
		},
		data() {
			return {
				wpData: wpData,
				productCrossSale: "",
        showFriend: false,
			};
		},
		watch: {
			"product.quantity": function (newValue, oldValue) {
				// switch (event_type) {
				//   case "add":
				//     sendAddToCart(productObj);
				//     break;
				//   case "remove":
				//     sendRemoveFromCart(productObj);
				//     break;
				// }
				//console.log('new : ' + newValue);
				//console.log('old : ' + oldValue);
			},
		},
		mounted() {
			//this.$store.dispatch("getSale", this.product.id);
			this.$root.$emit("openPop");
			if (
				this.product &&
				typeof this.product.cross_sell_ids != "undefined" &&
				this.product.cross_sell_ids.length > 0
			) {
				this.$ajax({
					method: "GET",
					url: cache_url + "products/" + this.product.cross_sell_ids[0] + ".json",
					//url: homeUrl + "ajax.php",
					// params: {
					//   getProductById: "",
					//   id: this.product.cross_sell_ids[0]
					// }
				}).then((res) => {
					if (typeof res.data == "object") {
						let response = res.data;
						response.cross_sell_ids = [];
						this.productCrossSale = response;
					}
				});
			}
			let find_in_cart = this.$store.state.added.find((p) => p.id == this.product.id);
			if (typeof find_in_cart != "undefined") {
				this.product.quantity = find_in_cart.quantity;
			}
		},
		methods: {
			// Send google analytics tag for "friend product" add to cart event
			gaTag_friend() {
				if (this.friend === true) {
					let friendID = this.product.id;
					let parentID = this.$el.parentElement.parentElement.getAttribute("data-product-id");
					console.log("Product friend - Add to cart, Parent ID: " + parentID + " | Friend ID: " + friendID);
					if (typeof ga != "undefined") {
						ga.getAll()[0].send({
							hitType: "event",
							eventCategory: "Shop",
							eventAction: "Product friend - Add to cart",
							eventLabel: "Parent ID: " + parentID + " | Friend ID: " + friendID,
							eventValue: 0,
							nonInteraction: true,
						});
					}
				}
			},
			openPop() {
				this.$modal.hide("sales-pop");
				this.$modal.hide("minimum-order");
				if (typeof this.readonly == "undefined") {
					this.openPopupProduct([this.product, this.category ? this.category.id : false, this.index]).then(
						() => {
							this.$modal.show("prod-modal");

							var stateObj = {};
							history.pushState(
								stateObj,
								this.product.name,
								wpData.home_url + "/product/" + this.product.slug + "/"
							);
						}
					);
				}
			},

			// },
			removePermenent([product, event]) {
				this.$store.dispatch("removeFromPermanent", product);
			},
			toggleFav([product, event]) {
				this.$ajax({
					method: "POST",
					url: ajaxUrl,
					params: {
						action: "addToFav",
						id: product.id,
					},
				});

				// Add or remove from state
				if (this.$store.state.storedFavs.some((p) => p.id === product.id)) {
					this.$store.state.storedFavs = this.$store.state.storedFavs.filter((p) => p.id != product.id);
					sendRemoveFromFav(product);
				} else {
					this.$store.state.storedFavs.push(product);
					sendAddToFav(product);
				}
				localStorage.setItem("fav_products", this.$store.state.storedFavs);
			},
			openAboveGrid(e) {
        if (!this.friend) {
          $('.product_wrap.product_friend_show').filter(function() {
            let farthestProductWrap = $(e.target).parents('.product_wrap').last();
            return !$(this).is(farthestProductWrap);
          }).removeClass('product_friend_show');
        }

        $('.mobile-add-to-cart.show').removeClass('show');

				setTimeout(() => {
          this.$refs.prod_above.classList.add("show");
          this.showFriend = true;
          //console.log(e, $(e.target).closest('.product_wrap').find('.product_friend'));
          //$(e.target).closest('.product_wrap').find('.product_friend').fadeIn();
        }, 200);

        // setTimeout(() => {
        //   this.$refs.prod_above.classList.remove("show");
        // }, 5000);
			},
			closeAboveGrid(e) {
        this.$refs.prod_above.classList.remove("show");
        this.showFriend = false;
        //$(e.target).closest('.product_wrap').find('.product_friend').fadeOut(
				// if (this.productsView === "grid") {
				// 	this.$refs.prod_above.classList.remove("show");
        //   this.showFriend = false;
        //   //$(e.target).closest('.product_wrap').find('.product_friend').fadeOut();
				// } else {
				// 	window.closeAbove();
				// }
			},
      closeProductFriend(e) {
        this.showFriend = false;
        //$(e.target).closest('.product_wrap').find('.product_friend').fadeOut();
      },
			...mapActions([
				"selectType",
				"updateCart",
				"weightAndQuantityPopup",
				"incrementProduct",
				"decrementProduct",
				"removeProduct",
				"updateSelect",
				"openPopupProduct",
			]),
		},

		computed: {
			...mapState(["productsView"]),
			...mapGetters(["getSale", "getWeightText", "pricePer100", "pricePer100Text"]),
			weightText: function () {
				let text = this.getWeightText(this.product);
				if (this.product.text_after_weight) {
					text = text + " " + this.product.text_after_weight;
				}
				return text;
			},
			sale: function () {
				return this.getSale(this.product.id);
			},
			showbanner() {
				if (this.sale) {
					if (this.sale.type == 6 && this.sale.products_buy_quantity > 1) {
						return true;
					}
				}
				return false;
			},
			allItemsQuantity: function () {
				return this.product.variations.reduce((total, p) => {
					return total + p.quantity;
				}, 0);
				//return this.message.split('').reverse().join('')
			},
			isFav: function () {
				if (typeof this.$store.state.storedFavs !== "object") {
					return false;
				}

				return this.$store.state.storedFavs.some((p) => p.id === this.product.id);
			},
			productCrossel: function () {
				if (!this.product.cross_sell_ids) {
					return false;
				}
				var productCrosselFound = this.$store.state.products.find(
					(p) => p.id === this.product.cross_sell_ids[0]
				);
				if (productCrosselFound) {
					productCrosselFound.cross_sell_ids = [];
					return productCrosselFound;
				}
				return false;
			},
			totalPrice() {
				if (
					(this.product.type == "both" || this.product.type == "unitaskg") &&
					this.product.selected == "unit"
				) {
					return parseFloat(
						this.product.quantity *
							this.product.weight *
							/*0.001 **/
							this.product.price
					).toFixed(2);
				}
				return parseFloat(this.product.quantity * this.product.price).toFixed(2);
			},
			selectedText() {
				switch (this.product.selected) {
					case "unit":
						if (this.product.case) {
							return "מארז";
						}
						return "יח׳";
						break;
					case "kg":
						return "ק״ג";
						break;
				}
				return null;
			},
			unitPriceText: function () {
				switch (this.product.type) {
					case "unit":
						if (this.product.case) {
							return "מארז";
						}
						return "יח׳";
						break;
					case "kg":
						return "ק״ג";
						break;
					case "both":
						return "ק״ג";
						break;
					case "unitaskg":
						return "ק״ג";
						break;
				}
				return null;
			},
			isPermenentPage: function () {
				if (this.$route.name == "permenent") {
					return true;
				}
				return false;
			},
			isReadOnly: function () {
				if (typeof this.readonly != "undefined") {
					return true;
				}
				return false;
			},
		},
		components: {
			Product,
			Producttype,
			plus_svg,
			minus_svg,
			close_svg,
			snow,
			new_svg,
			pen,
		},
	};
</script>

<style lang="scss" scoped>
	@media (max-width: 480px) {
		.grid {
      .product_wrap {
        z-index: 3;

        &.product_friend_show {
          z-index: 4;
        }
      }
			.product {
				border-radius: 10px 10px 22px 22px;
				margin-bottom: 20px;

				.product_img_wrap {
					padding: 10px 0 0;

					.product_img {
						img {
							height: 155px;
							object-fit: contain;
						}
					}
				}

				.prod_bottom {
					padding-bottom: 33px;

					.mobile_only:not(.mobile-add-to-cart):not(.prod_above) {
						display: none !important;
					}

					.no_mobile:not(.mobile-add-to-cart):not(.prod_above) {
						display: block !important;
					}
				}

				.prod_above {
					top: 100%;
					height: 100%;
					opacity: 1;
					overflow: hidden;
					background: none;
					display: block;
					transition: none;

					.table100 {
						.addto_cart {
							height: 100%;
							padding-top: 65%;
						}

						.plus a,
						.minus a {
							width: 35px;
							height: 35px;
							border-radius: 100%;
							background: #fff;
							margin: 10px -15px 0;

							::v-deep path {
								fill: rgba(33, 53, 25, 0.9);
							}
						}

						input.addto_cart_num {
							font-size: 26px;
							font-weight: normal;
						}

						::v-deep .addto_amount {
							border: 0;
							width: 75%;
							margin-top: 1em;
							font-size: 17px;
							font-weight: 200;

							a.addto_amount_it {
								font-size: 17px;
								font-weight: 200;
								transition: none;

								&:after {
									content: "";
									position: absolute;
									bottom: -2px;
									right: 0;
									border-bottom: 1px solid #a2ff8b;
									width: 0;
									margin: 0 25% 0 0;
									-webkit-transition: 300ms ease all;
									-o-transition: 300ms ease all;
									transition: 300ms ease all;
								}

								&.active {
									font-weight: 900;
									color: #a2ff8b;
									background: none;
									position: relative;

									&:after {
										width: 50%;
									}
								}
							}
						}
					}
				}

				.mobile-add-to-cart {
					height: 33px;
					background: #355731;
					transition: 400ms ease all;
					position: absolute;
					bottom: 0;
					right: 0;
					left: 0;
					z-index: 2;

					& > a {
						background: #355731;
						color: #fff;
						padding: 5px 0;
						text-align: center;
						display: block;
						position: absolute;
						bottom: 0;
						right: 0;
						left: 0;
					}

					&.show {
						height: 100%;
						background: #355731cc;

						& > a {
							display: none;
						}

						.prod_above {
							display: block;
							top: 0;
						}
					}

					.in_cart {
						display: flex;
						align-items: center;
						justify-content: center;
						gap: 3px;

            .addto_amount {
              width: auto;
              font-weight: normal;
              font-size: 16px;
              line-height: 1.42857143;
              padding: 0;
              height: auto;
              margin-right: 1px;
            }
					}
				}
			}

			.product_friend {
				position: absolute;
				right: 100%;
				border-radius: 0 0 25px 25px;

				.pp_friend_title {
					text-align: right;
					padding: 0 10px;
				}

				& > .m_prod_above_close a {
					left: 2px;
					right: auto;
					top: 3px !important;
				}

				.product_wrap {
					padding: 0;

					.product {
						margin: 0 !important;
						min-width: 0;
						border-radius: 0 0 22px 22px;

						.addto_cart {
							padding-top: 47%;
						}

						.addto_cart_num {
							color: #fff;
						}

						::v-deep .addto_amount {
							background: none !important;
							color: #fff;
						}

						::v-deep .m_prod_above_close a {
							top: 15px;

							path {
								fill: #fff !important;
							}
						}
					}
				}
			}

			.product_wrap:nth-child(even) > .product_friend {
				left: 100%;
				right: auto;
			}
		}
	}
</style>

<style scoped>
	.pod_icon_wrap .pod_icon {
		margin-left: 5px;
		margin-bottom: 5px;
		display: flex;
		align-items: center;
		column-gap: 3px;
	}
	.pod_icon_wrap .pod_icon:last-child {
		margin-left: 0px;
		margin-bottom: 0;
	}
	.pod_icon_wrap .pod_icon svg {
		height: 15px;
	}
	.pod_icon_wrap .pod_icon.vegan {
		background-color: #df9fb2;
	}
	.pod_icon_wrap .pod_icon.frozen {
		background-color: #8ed5ea;
	}
	.pod_icon_wrap .pod_icon.israeli {
		background-color: #5a99e3;
		height: 39px;
		line-height: 13px;
	}
	.pod_icon_wrap .pod_icon.tollmans img {
		height: 35px;
		margin: 6px 0 0 -10px;
	}
	span.pr_title_note.pricePer100 {
		font-size: 10px;
	}
	.prod_bottom .mobile_only span.pr_title_note {
		display: inline;
	}
	.prod_bottom .mobile_only span.pricePer100 {
		position: absolute;
		bottom: 5px;
	}
	span.mobile_only h3.pr_title {
		padding-left: 20px;
	}
	.new-product:not(.mobile_only) {
		position: absolute;
		bottom: 0;
		right: 8px;
		width: 42px;
	}
	.new-product svg {
		fill: #fff;
	}
	.new-product.mobile_only {
		width: 42px;
	}
</style>
<style>
	.product a.edit-link {
		position: absolute;
		top: 5px;
		right: 30px;
		padding: 10px 15px;
		z-index: 3;
	}
	a.edit-link svg {
		width: 17px;
	}
	.product a.edit-link svg path {
		fill: #999;
		transition: 300ms ease fill;
	}
	.product a.edit-link:hover svg path {
		fill: #1e824c !important;
	}
</style>
